// ── Oldalak, ahol a LEBEGŐ CTA-k nem jelennek meg ────────────────────────────
// A mérőoldalakon (eszközteszt) a jobb alsó widget és a képernyő aljára
// ragadó sáv rátakar a tesztfelületre – a kar-vizualizációra, az egérpályára,
// a billentyűzetrajzra –, és mérés közben elvonja a figyelmet. Ezeken az
// oldalakon a modulok a SAJÁT, kontextushoz illő CTA-jukat adják a tartalom
// alján, tehát a kapcsolatfelvétel útja nem vész el.
//
// A lista SZÁNDÉKOSAN egy helyen van: a FloatingContactWidget és a
// MobileCTABar is innen olvassa, így nem tud szétcsúszni, hogy melyik oldalon
// mi látszik. Új oldal felvétele egy sor.
//
// (A /diagnosztika nincs a listán: az önálló statikus oldal a frontend
// image-ből, oda ezek a React-komponensek el sem jutnak.)
export const CTA_MENTES_OLDALAK = ['/eszkozteszt', '/nyitva', '/hivtal'];

// ── CSUPASZ oldalak: se fejléc, se lábléc ────────────────────────────────────
// A /nyitva és a /hivtal SMS-ből nyíló, egyetlen döntésre kihegyezett
// landingek: oda egy nem fogadott hívás után érkezik a látogató, mobilon,
// türelmetlenül. A teljes navigáció és a nagy lábléc itt nem segít, csak
// elviszi a figyelmet az egyetlen fontos akciótól (visszahívás-kérés).
// Saját, minimál láblécet visznek.
export const CSUPASZ_OLDALAK = ['/nyitva', '/hivtal'];

/** Csupasz (fejléc/lábléc nélküli) oldal-e ez az útvonal? */
export const csupaszUtvonal = (pathname = '') =>
  CSUPASZ_OLDALAK.some((p) => pathname === p || pathname.startsWith(`${p}/`));

/** Az adott útvonalon el kell-e rejteni a lebegő CTA-kat? Az aloldalakra
 *  (pl. /eszkozteszt/valami) is érvényes. */
export const ctaMentesUtvonal = (pathname = '') =>
  CTA_MENTES_OLDALAK.some((p) => pathname === p || pathname.startsWith(`${p}/`));
